import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import { ActiveLabel } from '../../parts/parts';

import classes from './Legend.module.scss';

const Legend = ({ labelChange, showTotal, showUtil, showActive }) => {
  const { t } = useTranslation(['activity']);

  return (
    <div className={classes.legend}>
      <ActiveLabel
        labelChange={labelChange}
        name="totalLicense"
        value={showTotal}
        text={t('activity:customers.TOTAL_LICENSES')}
        className={classes.legend_total}
      />
      <ActiveLabel
        labelChange={labelChange}
        name="utilizedLicense"
        value={showUtil}
        text={t('activity:customers.TOTAL_USERS')}
        className={classes.legend_util}
      />
      <ActiveLabel
        labelChange={labelChange}
        name="activeUsers"
        value={showActive}
        text={t('activity:customers.ACTIVE_USERS')}
        className={classes.legend_active}
      />
    </div>
  );
};

Legend.propTypes = {
  labelChange: PropTypes.func,
  showTotal: PropTypes.bool,
  showUtil: PropTypes.bool,
  showActive: PropTypes.bool
};

export default Legend;
